<template>
    <div class="homePage">
        <div class="paper" :style="{width:WIDTH+'px'}">
            <transition name="move" mode="out-in">
                <keep-alive :include="tagsList">
                    <router-view></router-view>
                </keep-alive>
            </transition>
        </div>
    </div>
</template>
<script>
    export default {
        name:"paper",
        data() {
            return {
                tagsList:[],
                WIDTH:1024,//平时1024 进入考试页面：1254
            }
        },
        components:{},
        watch: {
            $route: {
                handler: function(val, oldVal){
                    if(val.path == '/problem'){
                        this.WIDTH = 1254
                    }
                    if(oldVal.path == '/problem'){
                        this.WIDTH = 1024
                    }
                },
                deep: true
            }
        },
        computed:{},
        created(){},  
        mounted(){
            let href_ = window.location.href.split('#/')[1]
            let lv = href_.indexOf('?')!=-1? href_.split('?')[0]:''
            if(lv == 'problem'){
                this.WIDTH = 1254
            }
        },
        methods:{}
    }
</script>
<style scoped lang="less">
    .homePage{
        height: 100%;
        width: 100%;
        // background-color: rgb(234, 234, 234);
        background: -webkit-linear-gradient(top, #3D72D6, #A8BBD4);
        background: linear-gradient(to bottom, #3D72D6, #A8BBD4);
        .paper{
            // width: 1024px;
            height: 100%;
            margin: 0 auto;
            background: #fff;
            overflow-x: hidden;
            overflow-y: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/paper.vue